import { render } from "./EmergencyPreparedness.vue?vue&type=template&id=8908e3bc"
import script from "./EmergencyPreparedness.ts?vue&type=script&lang=js&external"
export * from "./EmergencyPreparedness.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__